import {Typography} from "@material-ui/core";
import {useTagsBadgeStyles} from "./TagsBadgeStyles";
import PropTypes from "prop-types";

const TagsBadge = (props) => {
    const classes = useTagsBadgeStyles()

    return (
        <Typography className={classes.root} variant="caption"
                    style={{color: props.txtColor, backgroundColor: props.bgColor}}>
            {props.name}
        </Typography>
    )
}

TagsBadge.propTypes = {
    txtColor: PropTypes.string.isRequired,
    bgColor: PropTypes.string.isRequired
}

export default TagsBadge;
